const acronym = (...texts: (string | undefined)[]): string =>
  (texts ?? []).map((text) => (text ? text[0]!.toUpperCase() : '')).join('');

export { acronym };
